import { MarkerType } from 'reactflow';

const defaultEdgeOptions = {
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: '#ddd',
  },
  markerStart: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: '#ddd',
    orient: 'auto-start-reverse'
  },
  style: {
    strokeWidth: 2,
    stroke: '#ddd',
  },
}

const nodeStyleSizeByType = {
  input: { width: 50, height: 50 },
  output: { width: 50, height: 50 },
  default: { width: 200, height: 100 },
  http_request: { width: 200, height: 100 }
}

const defaultNodeOptions = {
  type: 'default',
  style: nodeStyleSizeByType.default
}

const getNodeStyleSizeByType = (type) => {
  return nodeStyleSizeByType[type] || nodeStyleSizeByType.default
}

export { defaultEdgeOptions, defaultNodeOptions, getNodeStyleSizeByType }
